import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class CipherService {
  set(key: string, value: string) {
    const encrypted = CryptoJS.AES.encrypt(value, key);
    return encrypted.toString();
  }

  get(key: string, value: string) {
    const decrypted = CryptoJS.AES.decrypt(value, key);
    return decrypted.toString(CryptoJS.enc.Utf8);
  }

  encryptParam(param: string): string {
    return this.set(environment.pathParamsKey, param);
  }

  decryptParam(param: string, isNumber = false): string | number | undefined | null {
    if (!param) return null;

    try {
      const decrypted = this.get(environment.pathParamsKey, param);

      if (isNumber) return Number(decrypted);

      return decrypted;
    } catch {
      return undefined;
    }
  }

  decryptAuth(param: string): string | undefined | null {
    if (param) return null;

    try {
      return this.get(environment.oauthStorageKey, param);
    } catch {
      return undefined;
    }
  }
}
